import { Component, Input } from "@angular/core";
import { IIosFullscreenComponent } from "@karma-games/angular-devkit/src/lib/modules/ios-fullscreen";

@Component({
    selector: "client-ios-fullscreen",
    templateUrl: "./client-ios-fullscreen.component.html",
    styleUrls: ["./client-ios-fullscreen.component.scss"]
})
export class ClientIosFullscreenComponent implements IIosFullscreenComponent {
    @Input() closeBtnImg: string = "assets/images/ui-elements/ui_close_button.png";
    @Input() swipeUpImg: string = "assets/images/ios-fullscreen/hand.png";
    @Input() isHintForClosing: boolean = false;
}
